<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
          v-if="user && user.IDStB"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br /><br />
        <!-- Título -->
        <div class="title">
          {{ title }}
        </div>
        <v-row align="center">
          <v-col cols="12">
            <label class="label-white">Sede del trámite</label>
            <v-select
              class="v-select-label-white"
              v-model="sede"
              :items="sedes"
              item-text="sede.nombre"
              item-value="sede.IDF"
              label="Selecciona la sede"
              persistent-hint
              return-object
              single-line
              v-on:change="loadData"
            ></v-select>
          </v-col>
        </v-row>
        <div v-if="pagos.length > 0">
          <br />
          <!-- Tabla para pantallas grandes -->
          <v-simple-table class="d-none d-md-block">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Concepto</th>
                  <th class="text-left">Monto</th>
                  <th class="text-left">Forma de pago</th>
                  <th class="text-left">Pagado Anterior</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(pagoData, pagoKey) in pagos"
                  :key="pagoKey"
                >
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.IDF }}</td>
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.Concepto }}</td>
                  <td v-bind:style="colorText(pagoData)">${{ pagoData.Monto }}</td>
                  <td v-bind:style="colorText(pagoData)">{{ pagoData.forma_de_pago_data.Nombre }}</td>
                  <td v-bind:style="colorText(pagoData)">
                    {{ pagoData.ultimo_pago == '' ? '-' : pagoData.ultimo_pago }}
                  </td>
                  <td>
                    <v-btn
                      color="success"
                      elevation="7"
                      large
                      @click="createCobranza(pagoData.IDF)"
                    >
                      Pagar
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- Acordeón para pantallas pequeñas -->
          <v-expansion-panels v-if="$vuetify.breakpoint.xs">
            <v-expansion-panel
              v-for="(pagoData, pagoKey) in pagos"
              :key="pagoKey"
              class="mt-1 rounded"
            >
              <v-expansion-panel-header
                class="pb-7"
                style="background-color: #e0e0e0; border-radius: 8px;"
              >
                #{{ pagoData.IDF }} - {{ pagoData.Concepto }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row style="margin-top: 10px;">
                  <v-col cols="12">
                    <p><strong>Monto:</strong> ${{ pagoData.Monto }}</p>
                    <p>
                      <strong>Forma de pago:</strong>
                      {{ pagoData.forma_de_pago_data.Nombre }}
                    </p>
                    <p>
                      <strong>Pagado Anterior:</strong>
                      {{ pagoData.ultimo_pago == '' ? '-' : pagoData.ultimo_pago }}
                    </p>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="success"
                      elevation="7"
                      large
                      @click="createCobranza(pagoData.IDF)"
                    >
                      Pagar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>
//  v-if="pagoData.pagadoAlumno == 0"
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "PaymentRegular",
  components: {
    // CardIeaApp,
    CardIeaAppMain, 
  },

  data: function() {
    return {
      title:"Efectuar pago",
      sede: {text:'', value:''},
      sedes:[],
      pagos:[],
      total:0,
      items:[],
      urlPay : ''
    }
  },

  methods: {
    async loadData() {
      console.log(this.sede)
      this.$API
        .get({
          url: "alumno-pagos-regulares?alumno="+this.user.IDStB+"&sede="+this.sede.sede.IDF,
          data: {},
        })
        .then((res) => {
          console.log(res)
          this.pagos = res;
        })
        .catch((err) => {
          console.log(err);
      });
    },

    colorText(pagoData) {
      let color = 'black';
      if(pagoData.block){
        color = '#888';
      }
      if(pagoData.pagado){
        color = 'green';
      }
      return {color:color}
    },

    canPay(pagoData) {
      return (!pagoData.block && !pagoData.pagado) ? true : false;
    },
    changeTotal(pagoData, index) {
      console.log(pagoData)
      pagoData.index = index;
      if(pagoData.check){
        this.total += pagoData.precioAPagar;
      }else{
        this.total -= pagoData.precioAPagar;
      }
      let selecteds = this.pagos.items.filter(d => {return d.check;})
      this.items = selecteds.map((value) => {return {id: value.IDStB, monto: value.precioAPagar, index:value.index }})
      console.log(this.items)
    },
    
    async createCobranza(id) {
      let dataSend = {
        alumno:this.user.IDStB
      };

      let url = "pago-concepto-regular/" + id;
     
      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then((res) => {
          //Se crea la cobranza primero
          if(res.id){
            this.pay(res)
          }else{
            alert('Pago en revisión')
          }
          
        });
    },
    async pay(res) {
      await this.$API
      .post({
        url: "alumno-pagos-regulares-pay/" + res.id,
        data: res
      }).then((resUrl) => {
        location.href = resUrl
      });
    }
  },
  
  mounted() {
    this.$API
      .get({
        url: "alumno-sedes/" + this.user.IDStB,
        data: {},
      })
      .then((res) => {
        this.sedes = res;
      })
      .catch((err) => {
        console.log(err);
    });
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
};
</script>
<style scoped>
/* Estilo para el título */
.title {
  color: white;
  font-size: 32px; /* Tamaño para pantallas grandes */
  font-weight: bold;
  padding-bottom: 10px;
}

/* Título para pantallas pequeñas */
@media (max-width: 768px) {
  .title {
    font-size: 24px; /* Tamaño para pantallas pequeñas */
    padding-bottom: 10px;
  }
}

::v-deep .label-white {
  color: white;
  font-weight: bold !important;
}

::v-deep .v-select-label-white .v-input__control {
  color: currentColor !important;
}

::v-deep .v-select-label-white .v-label {
  color: white !important;
}

::v-deep .v-select-label-white .v-select__selections {
  color: white !important;
}

::v-deep .v-select-label-white .v-input__control::placeholder {
  color: white !important;
}

::v-deep .v-icon__svg {
  height: 24px;
  width: 24px;
  fill: white !important;
}

::v-deep .v-input__control {
  display: flex;
  flex-direction: column;
  height: auto;
  flex-grow: 1;
  flex-wrap: wrap;
  min-width: 0;
  width: 100%;
}

::v-deep .theme--light.v-select .v-select__selections {
  color: white;
}

::v-deep .v-select:not(.v-select--is-multi).v-text-field--single-line .v-select__selections {
  flex-wrap: nowrap;
}

::v-deep .v-text-field fieldset, .v-text-field .v-input__control {
  color: white;
}

::v-deep .v-expansion-panel .v-icon__svg {
  fill: rgb(127, 124, 124) !important; /* Color gris oscuro para los íconos del acordeón */
}
</style>
